import { DisplayText } from '../../types'
import { NestedPartial } from '@vista/omnichannel-components-domain'
import {OccFormDisplayText} from '@vista/omnichannel-components-ui'
import {defaultOccFormDisplayText} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/display-text/form'

export interface GetFormDisplayTextProps {
    displayText?: NestedPartial<DisplayText>
}

export function getFormDisplayText(props:GetFormDisplayTextProps):OccFormDisplayText {
    const {displayText} = props
    return {
        ...defaultOccFormDisplayText,
        fieldOptionalSuffix: displayText?.form?.fieldOptionalSuffix || defaultOccFormDisplayText.fieldOptionalSuffix,
    }
}